export const FBLOGIN_REQUEST = 'FBLOGIN_REQUEST';
export const FBLOGIN_SUCCESS = 'FBLOGIN_SUCCESS';
export const FBLOGIN_FAILURE = 'FBLOGIN_FAILURE';
export const GOOGLE_LOGIN_REQUEST = 'GOOGLE_LOGIN_REQUEST';
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
export const GOOGLE_LOGIN_FAILURE = 'GOOGLE_LOGIN_FAILURE';